import { render, staticRenderFns } from "./tc-tab.vue?vue&type=template&id=f6414fdc&scoped=true&"
import script from "./tc-tab.vue?vue&type=script&lang=js&"
export * from "./tc-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6414fdc",
  null
  
)

export default component.exports